// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"4c6d2665","488":"85593752","517":"a4dfe75b","793":"d76ee11c"}[chunkId] + ".chunk.js";
};